export const transformVendorDoc = (doc) => {
  return doc?.map((eachDoc) => {
    return {
      ...eachDoc,
      file: JSON.parse(eachDoc?.file)
    }
  });
}